angular.module('aprima-provider-api')
    .factory('NoteRepository', ['AprimaRestangular', function (aprimaRestangular) {
        'use strict';

        var getNotes = function (filterId) {
        	return aprimaRestangular.get().all('notes/' + filterId).getList();
        };

        return {
            getNotes: getNotes
        };
    }]);